// Theme palettes. Each key maps to CSS variables applied at runtime.
export const THEMES = {
  terracotta: {
    label: "Terracotta (warm earthy)",
    swatch: "#D95D39",
    vars: {
      "--theme-primary": "#D95D39",
      "--theme-primary-hover": "#C24F2C",
      "--theme-primary-soft": "#FBE9E2",
      "--theme-secondary": "#6A7F66",
    },
  },
  saffron: {
    label: "Saffron (bright Indian)",
    swatch: "#E07B00",
    vars: {
      "--theme-primary": "#E07B00",
      "--theme-primary-hover": "#B86600",
      "--theme-primary-soft": "#FFE8CC",
      "--theme-secondary": "#264653",
    },
  },
  forest: {
    label: "Forest (calm green)",
    swatch: "#2A7F62",
    vars: {
      "--theme-primary": "#2A7F62",
      "--theme-primary-hover": "#1F6650",
      "--theme-primary-soft": "#D4ECE4",
      "--theme-secondary": "#C18A41",
    },
  },
  midnight: {
    label: "Midnight (cool blue)",
    swatch: "#1E5F8A",
    vars: {
      "--theme-primary": "#1E5F8A",
      "--theme-primary-hover": "#164967",
      "--theme-primary-soft": "#D7E7F1",
      "--theme-secondary": "#E07B00",
    },
  },
  royal: {
    label: "Royal (regal purple)",
    swatch: "#6B3FA0",
    vars: {
      "--theme-primary": "#6B3FA0",
      "--theme-primary-hover": "#542F82",
      "--theme-primary-soft": "#E8DEF5",
      "--theme-secondary": "#C8A951",
    },
  },
};

export const applyTheme = (key) => {
  const t = THEMES[key] || THEMES.terracotta;
  const root = document.documentElement;
  Object.entries(t.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  localStorage.setItem("pos_theme", key);

  // Override the hardcoded brand hex values across the app via a runtime stylesheet
  const primary = t.vars["--theme-primary"];
  const hover = t.vars["--theme-primary-hover"];
  const soft = t.vars["--theme-primary-soft"];
  let sheet = document.getElementById("theme-overrides");
  if (!sheet) {
    sheet = document.createElement("style");
    sheet.id = "theme-overrides";
    document.head.appendChild(sheet);
  }
  sheet.textContent = `
    .bg-\\[\\#D95D39\\]      { background-color: ${primary} !important; }
    .hover\\:bg-\\[\\#D95D39\\]:hover { background-color: ${primary} !important; }
    .hover\\:bg-\\[\\#C24F2C\\]:hover { background-color: ${hover} !important; }
    .text-\\[\\#D95D39\\]    { color: ${primary} !important; }
    .hover\\:text-\\[\\#D95D39\\]:hover { color: ${primary} !important; }
    .border-\\[\\#D95D39\\]  { border-color: ${primary} !important; }
    .bg-\\[\\#FBE9E2\\]      { background-color: ${soft} !important; }
    .focus-visible\\:ring-\\[\\#D95D39\\]:focus-visible { --tw-ring-color: ${primary} !important; }
    ::selection            { background: ${primary} !important; color: white !important; }
  `;
};

export const getCurrentTheme = () => localStorage.getItem("pos_theme") || "terracotta";
